import type { z } from "zod";

import { basePrayerSchema } from "./basePrayerSchema";

export const sectionItemPrayerSchema = basePrayerSchema;

export type SectionItemPrayer = z.infer<typeof sectionItemPrayerSchema>;
